import { render } from "./authenTication.vue?vue&type=template&id=126b09d3&scoped=true"
import script from "./authenTication.vue?vue&type=script&lang=js"
export * from "./authenTication.vue?vue&type=script&lang=js"

import "./authenTication.vue?vue&type=style&index=0&id=126b09d3&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_ZubV/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126b09d3"]])

export default __exports__